import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Link from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';

import { useProductLandingContext } from '../../contexts/useProductLanding';
import { useProductLandingClickstreamProps } from '../../hooks/useProductLandingClickstreamProps';

const externalLink = (chunks, link, personalizationClickstreamProps) => (
  <Link
    clickstreamProps={{
      ...personalizationClickstreamProps,
      elementName: 'footnote_link',
      elementPosition: 'footnotes',
    }}
    href={link}
    target="_blank"
    rel="noopener noreferrer"
    textDecoration="none"
    color="text.secondary"
  >
    {chunks}
  </Link>
);

function FootnotesSection() {
  const { productConfig } = useProductLandingContext();
  const personalizationClickstreamProps = useProductLandingClickstreamProps();
  const { footnotes: { divider = true, items = [] } = {} } = productConfig;

  if (items?.length === 0) {
    return null;
  }

  return (
    <>
      {divider && <Divider />}
      <div id="footnotes">
        {items.map((footnote) => (
          <Text
            key={footnote.id ?? footnote.text}
            id={`footnote-${footnote.id ?? footnote.text}`}
            size="xs"
            gutterBottom
          >
            <sup>{footnote.id}</sup>{' '}
            <FormattedMessage
              id={footnote.text}
              values={{
                externalLink: (chunks) => externalLink(chunks, footnote.link, personalizationClickstreamProps),
              }}
            />
          </Text>
        ))}
      </div>
    </>
  );
}

export default FootnotesSection;
